import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as collectionsActions from '~data/actions/collections';

import PickerIcon from '~co/picker/icon';

export default function CollectionChangeIcon({ _id = 0, ...props }) {
  const dispatch = useDispatch();
  const actions = useMemo(
    () => bindActionCreators(collectionsActions, dispatch),
    [dispatch],
  );

  const onLink = (link) =>
    new Promise((res, rej) =>
      actions.oneUpdate(_id, { cover: [link] }, res, rej),
    );

  const onFile = (file) =>
    new Promise((res, rej) => actions.oneCoverUpload(_id, file, res, rej));

  return (
    <PickerIcon {...props} onLink={onLink} onFile={onFile} />
  );
}
